import {useEffect} from 'react';
import {useRouteError} from 'react-router-dom';
import posthog from 'posthog-js';
import {ErrorScreen} from '~/components/error-screen';

export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (error == null) {
      return;
    }
    posthog.captureException(error);
  }, [error]);

  return <ErrorScreen showRefresh />;
}
